import TokenService from "@/services/storage.service";

export default async function redirectWholesalerFromDashboard(to, next, store) {
  if (to.name !== "dashboard" || !TokenService.getToken()) {
    return false;
  }

  let user = store.getters.getMe || TokenService.getUser();
  if (!user) {
    await store.dispatch("me").catch(() => null);
    user = store.getters.getMe || TokenService.getUser();
  }

  const isWholesaler = user?.roles?.some((item) =>
    ["wholesaler", "wholesalerStaff"].includes(item.name)
  );

  if (isWholesaler) {
    next({ name: "wholesaler" });
    return true;
  }

  return false;
}
